import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the PurchasesPerCategoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-production-order',
  templateUrl: 'production-order.html',
})
export class ProductionOrderPage {

  chartData: any;
  chartLabels: any;
  chartCheck: any;
  total_orders: any;
  //datatable
  rows = [];
  temp = [];
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'total', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
  ) {
    this.getAnalyticsData();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('init_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('end_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'get_elements_orders', params, {})
      .subscribe(async response => {
        this.total_orders = response['total_orders'];
        //chart
        this.chartData = response['chart_data']; //total's
        this.chartLabels = response['chart_labels'];//Dates
        //list
        this.rows = response['elements'];
        this.temp = response['elements'];
        //
        this.chartCheck = true;//boolean check
      });
  }

  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  onSort(event) {
    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          this.rows.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.rows.sort((a, b) => b.name.localeCompare(a.name));
        }
        break;
      case 'total':
        if (event.newValue == 'asc') {
          this.rows.sort((a, b) => a.total - b.total);
        } else {
          this.rows.sort((a, b) => b.total - a.total);
        }
        break;
    }
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = [];
    // filter our data
    this.temp.forEach(doc => {
      if (doc.name.toLowerCase().includes(val)) {
        temp.push(doc);
      } else if (doc.tags.toString().toLowerCase().includes(val)) {
        temp.push(doc);
      }
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const body = {
      data: this.rows,
      date1: moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'),
      date2: moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'),
      extras: { 'Total orders': this.total_orders }
    };
    this.http.post(this.globals.analytics_path + 'export/analytics', body, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/production-order/production-order.ts